import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import glasses from '../../assets/images/mine/3d-glasses.png';
import Profile from './Profile';
import axios from 'axios';
import { useSelector } from 'react-redux';
import StudentResultModal from '../../components/StudentResultModal';

const baseURL = process.env.REACT_APP_BASE_URL;

function Topbar() {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState({ students: [], instructors: [] });
  const [showDropdown, setShowDropdown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false); // State to control modal visibility
  const [studentData, setStudentData] = useState(null); // State to store student data
  const { user } = useSelector(state => state.userState);

  const handleInputChange = async (event) => {
    const value = event.target.value;
    setSearchTerm(value);
    
    if (value.length > 0) {
      setShowDropdown(true);
      setLoading(true);
      setError(null);
      
      try {
        const response = await axios.get(`${baseURL}/administration/search/?query=${value}`);
        setSearchResults(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    } else {
      setShowDropdown(false);
      setSearchResults({ students: [], instructors: [] });
    }
  };

  const handleSuggestionClick = async (studentId) => {
    // Fetch student detailed data
    try {
      const response = await axios.get(`${baseURL}/students/student-records/${studentId}/`);
      setStudentData(response.data); // Set student data
      setShowModal(true); // Show the modal
    } catch (err) {
      console.error(err);
      setError(err.message);
    }

    setSearchTerm(''); // Clear the input after selection
    setShowDropdown(false); // Hide dropdown
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setStudentData(null); // Reset student data when closing modal
  };

  return (
    <>
      <nav className="navbar top-bar navbar-light border-bottom py-0 py-xl- 3">
        <div className="container-fluid p-0">
          <div className="d-flex align-items-center w-100">
            <div className="d-flex align-items-center d-xl-none">
              <Link to='/' className="navbar-brand">
                <img className="light-mode-item navbar-brand-item h-30px" src={glasses} alt=""/>
              </Link>
            </div>

            <div className="navbar-expand-xl sidebar-offcanvas-menu">
              <button className="navbar-toggler me-auto" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasSidebar" aria-controls="offcanvasSidebar" aria-expanded="false" aria-label="Toggle navigation" data-bs-auto-close="outside">
                <i className="bi bi-text-right fa-fw h2 lh-0 mb-0 rtl-flip" data-bs-target="#offcanvasMenu"></i>
              </button>
            </div>
            
            <div className="navbar-expand-lg ms-auto ms-xl-0">
              <button className="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTopContent" aria-controls="navbarTopContent" aria-expanded="false" aria-label="Toggle navigation">
                <span className="navbar-toggler-animation">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
              </button>

              <div className="collapse navbar-collapse w-100" id="navbarTopContent">
                {user.is_admin && (
                  <div className="nav my-3 my-xl-0 flex-nowrap align-items-center">
                    <div className="nav-item w-100">
                      <form className="position-relative" onSubmit={(e) => e.preventDefault()}>
                        <input 
                          className="form-control pe-5 bg-secondary bg-opacity-10 border-0" 
                          type="search" 
                          placeholder="بحث" 
                          aria-label="Search"
                          value={searchTerm}
                          onChange={handleInputChange}
                        />
                        <button 
                          className="bg-transparent px-2 py-0 border-0 position-absolute top-50 end-0 translate-middle-y" 
                          type="submit"
                        >
                          <i className="fas fa-search fs-6 text-primary"></i>
                        </button>
                        {showDropdown && (
                          <div className="dropdown-menu show" style={{ position: 'absolute', width: '100%' }}>
                            {loading && <div className="dropdown-item">Loading...</div>}
                            {error && <div className="dropdown-item text-danger">Error: {error }</div>}
                            {searchResults.students.length > 0 && (
                              <>
                                <div className="dropdown-header">نتائج بحث الطالب</div>
                                {searchResults.students.map((student, index) => (
                                  <Link 
                                    key={index} 
                                    className="dropdown-item" 
                                    onClick={() => handleSuggestionClick(student.id)}
                                  >
                                    {student.name} - {student.phone_number}
                                  </Link>
                                ))}
                                <div className="dropdown-divider"></div>
                              </>
                            )}
                            {searchResults.instructors.length > 0 && (
                              <>
                                <div className="dropdown-header">نتائج بحث المدرس</div>
                                {searchResults.instructors.map((instructor, index) => (
                                  <Link 
                                    key={index} 
                                    className="dropdown-item" 
                                    to={`/instructor-records/${instructor.id}`} 
                                    onClick={() => handleSuggestionClick(`/instructor/${instructor.id}`)}
                                  >
                                    {instructor.name} - {instructor.phone_number}
                                  </Link>
                                ))}
                              </>
                            )}
                          </div>
                        )}
                      </form>
                    </div>
                  </div>
                )}
              </div>
            </div>
            
            <div className="ms-xl-auto">
              <ul className="navbar-nav flex-row align-items-center">
                <li className="nav-item ms-2 ms-md-3 dropdown">
                  <Profile />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </nav>

      {/* Modal for displaying student data */}
      <StudentResultModal 
        show={showModal} 
        handleClose={handleCloseModal} 
        studentData={studentData} 
      />
    </>
  );
}

export default Topbar;